import styled, { css } from "styled-components";

import { ScreenPlatform } from "@store/ducks/Screen/screen.type";

interface ContainerProps {
  platform: ScreenPlatform;
  /** Inside the CAN telemetry tabs the header spacing is already handled by the shell */
  embedded?: boolean;
}

export const Container = styled.div<ContainerProps>`
  padding: 20px;
  padding-top: 85px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
  margin-top: ${(p) => (p.platform === "mobile" && !p.embedded ? "5rem" : "0")};

  /*
   * The "body .page" rule of the global stylesheet forces the padding that clears the fixed header,
   * and it wins over a plain class. Embedded in the CAN telemetry tabs there is no header to clear,
   * so the rule is restated with the same two-class weight the other tabbed reports use.
   */
  ${(props) => props.embedded && css`
    &.page {
      padding-top: 0;
    }
  `}

  .toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    background-color: #fff;
  }

  .toolbar > * {
    flex: 0 0 auto;
  }

  .toolbar .vehicle-input {
    min-width: 280px;
  }

  .toolbar .day-input {
    min-width: 170px;
  }

  .toolbar .info-block {
    display: flex;
    flex-direction: column;
    padding: 0 8px;
    border-left: 1px solid rgba(0, 0, 0, 0.08);
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
  }

  .toolbar .info-block strong {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.87);
  }

  .source-chip {
    align-self: center;
  }

  .source-chip.cache {
    background-color: #e3f2fd;
    color: #0d47a1;
  }

  .source-chip.data {
    background-color: #fff3e0;
    color: #e65100;
  }

  .body {
    display: flex;
    flex: 1;
    gap: 16px;
    overflow: hidden;
  }

  .sidebar {
    width: 320px;
    min-width: 320px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    background-color: #fff;
    padding: 16px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .sidebar .field-group {
    display: flex;
    flex-direction: column;
  }

  .sidebar .field-group .group-title {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.54);
    margin-bottom: 4px;
  }

  .sidebar .field-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .sidebar .field-row .color-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    flex: 0 0 12px;
  }

  .sidebar .actions {
    display: flex;
    gap: 8px;
  }

  .chart-area {
    flex: 1;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    background-color: #fff;
    padding: 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
  }

  .chart-area .zoom-controls {
    position: absolute;
    top: 12px;
    right: 12px;
    display: flex;
    gap: 4px;
    z-index: 1;
  }

  .chart-area .chart-wrapper {
    flex: 1;
    position: relative;
    min-height: 320px;
  }

  .chart-area .empty-state {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    color: rgba(0, 0, 0, 0.54);
    text-align: center;
    padding: 24px;
  }

  .chart-area .empty-state .icon {
    font-size: 56px;
    color: rgba(0, 0, 0, 0.26);
  }
`;
